module.exports = __webpack_public_path__ + "static/fonts/Oxanium-Light.288758b7.ttf";